export const ApiEndpoints = {
  signIn: () => "user/sign-in",
  signOut: () => "user/sign-out",
  userList: () => "user/user",
  userOne: (id: number) => `user/user/${id}`,
  userInvite: () => "user/invite",
  userRegister: () => "user/register",
  userEnable: (id: number) => `user/user/${id}/enable`,
  userDisable: (id: number) => `user/user/${id}/disable`,
  userFinishRegistration: () => `user/finish-registration`,
  userResendVerification: () => "user/resend-registration-verification",
  userAcceptInvitation: () => "user/accept-invitation",
  userProfile: () => "user/my-profile",
  requestPasswordReset: () => "user/request-password-reset",
  resetPassword: () => "user/reset-password",
  changePassword: () => "user/change-password",
  organizationList: () => "user/organizations",
  organizationOne: (id: number) => `user/organizations/${id}`,
  resultList: () => "surehand/results",
  resultOne: (id: number) => `surehand/results/${id}`,
  systemTimezones: () => "system/timezones",
  systemLanguages: () => "system/language",
  systemCountries: () => "system/countries",
};
